import {Component, Input, OnInit} from '@angular/core';
import {CasiCloseOptions, FormModes} from '../../common/constants.lib';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {DialogContentBase, DialogModule, DialogRef, KENDO_DIALOGS} from '@progress/kendo-angular-dialog';
import {LoggerService} from '../../shared/logger.service';
import {CommonModule} from '@angular/common';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {EditorModule} from '@progress/kendo-angular-editor';
import {InputsModule} from '@progress/kendo-angular-inputs';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {LabelModule} from '@progress/kendo-angular-label';
import {DropDownsModule} from '@progress/kendo-angular-dropdowns';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {AutoFocusDirective} from '../../directives/auto-focus.directive';
import {Discipline, OrganisationDisciplineType} from '../../models/models.lib';
import {DisciplineService} from '../../discipline/discipline.service';

@Component({
  selector: 'casi-organisation-discipline-add',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FontAwesomeModule,
    DialogModule,
    EditorModule,
    InputsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    LayoutModule,
    AutoFocusDirective,
    KENDO_DIALOGS
  ],
  templateUrl: './organisation-discipline-add.html',
  styleUrl: './organisation-discipline-add.scss'
})
export class OrganisationDisciplineAdd  extends DialogContentBase implements OnInit {
  private _organisationDiscipline: OrganisationDisciplineType | undefined;

  @Input() title: string = 'Title Not Set';

  @Input({ required: true }) set organisationDiscipline(val: OrganisationDisciplineType) {
    this._organisationDiscipline = val;
    this.addForm.patchValue(this._organisationDiscipline);
  }
  get organisationDiscipline(): OrganisationDisciplineType | undefined {
    return this._organisationDiscipline;
  };

  disciplines: Discipline[] = [];
  addForm: FormGroup;

  constructor(
    public override dialog: DialogRef,
    private fb: FormBuilder,
    private logger: LoggerService,
    private dataService: DisciplineService
  ) {
    super(dialog);
    this.addForm = this.fb.group(
      {
        id: [null, []],
        discipline_id: [null, [Validators.required]],
        organisation_id: [null, [Validators.required]]
      }
    );
  }

  //#region Form

  get f() {
    return this.addForm.controls;
  }
  get discipline_id() {
    return this.addForm.get('discipline_id');
  }

  //#endregion

  ngOnInit(): void {
    this.logger.debug('ngOnInit...');
    this.loadDisciplines();
  }

  public onCancelAction(): void {
    this.logger.debug(`onCancelAction...`);
    this.dialog.close({ text: CasiCloseOptions.Cancelled });
  }

  public onSaveAction(): void {
    this.logger.debug(`onSaveAction...`, this.addForm.value);
    if (this.addForm.status !== 'INVALID')
      this.dialog.close({ text: CasiCloseOptions.Saved });
  }

  private loadDisciplines(): void {
    this.dataService.get().subscribe({
      next: data => this.disciplines = data ? data.filter((d: Discipline) => d.active) : [],
      error: err => console.error('Failed to load disciplines', err)
    });
  }
}
